import { useState } from "react";

import Header from "../../components/headerBlue/header.component";
import Sidebar from "../../components/sidebar/sidebar.component";

const PageWrapper = ({ children, sidebarData }) => {
    const [showSidebar, setShowSidebar] = useState(false);
    return (
        <>
            <Header
                onClick={() => setShowSidebar(!showSidebar)}
                showSidebar={showSidebar}
            />
            <Sidebar showSidebar={showSidebar} sidebarData={sidebarData} />
            {/* spacer for fixed header */}
            <div className="h-16" />
            {/* main content area */}
            <main className="lg:ml-60 min-h-[calc(100vh-64px)] bg-gray-50 pb-5 flex flex-col overflow-y-auto">
                {children}
            </main>
        </>
    );
};

export default PageWrapper;
